// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"130":"4bc5456c","891":"9a78438f"}[chunkId] + ".js";
};